import { gql } from "@apollo/client";

export const QUERY_TV_ENERGY_DATA = gql`
  query getTvEnergyData {
    getTvEnergyData {
      drivers {
        driver
        driverName
        timestamp
        tvPercent
        processedPercent
        estimatedTarget
        deltaToRedCar
        deltaToBlueCar
        deltaToLeader
        processedPercentByLap {
          lapNumber
          processedPercent
        }
        estimatedTargetByLap {
          lapNumber
          estimatedTarget
        }
      }
    }
  }
`;

export const QUERY_TV_ENERGY_CONNECTION_STATE = gql`
  query getTvEnergyConnectionState {
    getTvEnergyConnectionState {
      streamLink
      isConnected
      timingFeedOffset
    }
  }
`;

export const SUBSCRIBE_TV_ENERGY_DATA = gql`
  subscription newTvEnergyData {
    newTvEnergyData {
      driver
      driverName
      lapNumber
      timestamp
      tvPercent
      processedPercent
      estimatedTarget
      deltaToRedCar
      deltaToBlueCar
      deltaToLeader
    }
  }
`;

export const SUBSCRIBE_TV_ENERGY_CONNECTION_STATE = gql`
  subscription newTvEnergyConnectionState {
    newTvEnergyConnectionState {
      streamLink
      isConnected
      timingFeedOffset
    }
  }
`;

export const SUBSCRIBE_RESET_TV_ENERGY_DATA = gql`
  subscription resetTvEnergyData {
    resetTvEnergyData
  }
`;

export const START_TV_ENERGY_STREAM = gql`
  mutation startTvEnergyStream($streamLink: String!) {
    startTvEnergyStream(streamLink: $streamLink)
  }
`;

export const STOP_TV_ENERGY_STREAM = gql`
  mutation stopTvEnergyStream {
    stopTvEnergyStream
  }
`;
